import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const findAppsRoute: InvariantJiraRoute = {
	name: 'marketplace-index',
	path: '/jira/marketplace',
};
